import BasePostPreview from './BasePostPreview';

const NewsPostPreview=({...props})=>{
  return (
    <BasePostPreview key={props.post.slug.current} {...props} />
  )
}

export default NewsPostPreview